import { Component, inject } from '@angular/core';
import { NgFor } from '@angular/common';
import { CategoryTileComponent } from '../../../../shared/ui/category-tile/category-tile.component';
import { ProductCardComponent } from '../../../../shared/ui/product-card/product-card.component';
import { CategoryService } from '../../../../core/services/category.service';
import { ProductService } from '../../../../core/services/product.service';

@Component({
  selector: 'app-tienda',
  standalone: true,
  imports: [NgFor, CategoryTileComponent, ProductCardComponent],
  templateUrl: './tienda.component.html',
  styleUrl: './tienda.component.scss'
})
export class TiendaComponent {
  private cs: any = inject(CategoryService);
  private ps: any = inject(ProductService);
  cats = this.cs.list();
  destacados = this.ps.list(); // luego lo filtras a tus destacados reales
}
